import { Button } from 'primereact/button';
import "./styles/ButtonImage.scss";
const ButtonImage = (props) => {
    return (
        <Button

            {...props}
            className={`button-imagen`}
        //style={{width: props.width ? props.width: "100%",height: props.height}}
        ></Button>
    );
}

export default ButtonImage;